import { getAccessToken } from './apiClient';

const ROLE_CLAIM = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role';

/** True if the access JWT includes the admin role (sole admin email at login). */
export function accessTokenIsAdmin(token) {
    if (!token) return false;
    try {
        const payloadPart = token.split('.')[1];
        if (!payloadPart) return false;
        const json = atob(payloadPart.replace(/-/g, '+').replace(/_/g, '/'));
        const payload = JSON.parse(json);
        const role = payload.role || payload[ROLE_CLAIM];
        if (Array.isArray(role)) {
            return role.some((r) => String(r).toLowerCase() === 'admin');
        }
        return String(role || '').toLowerCase() === 'admin';
    } catch {
        return false;
    }
}

/** True when the signed-in session is the platform admin (JWT and/or user flag). */
export function sessionIsAdmin(user) {
    return Boolean(user?.isAdmin) || accessTokenIsAdmin(getAccessToken());
}
